module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Bold.9634168f.woff";